/* 
    Dependencies
*/
import activeUsers from "../../components/ActiveUsers/ActiveUsers";
import SummerNote from "../../components/SummerNoteEditor/SummerNote";
import * as townhallService from "../../Service/TownHallService";
import * as reportService from "../../Service/Report.service";
import * as ReportSchemaModel from "../../Models/ReportSchema";
import firestore from "../../config/firebase";
import firebase from "firebase";
import { toasterModel, toasterColor } from "../../Models/ToasterModel";
import * as utility from "../../Utility/commonUtilities";
import { mapGetters } from "vuex";
import WebinarPrint from "../../components/WebinarPrintComponent/WebinarPrint";

export default {
  name: "webinar",

  components: {
    activeUsers,
    SummerNote,
    WebinarPrint,
  },

  data: () => {
    return {
      activeTab: 0,
      contentId: "addContent",
      webinarReport: "",
      userQuestionDetails: "",
      question: "",
      uid: "",
      ispulseQuestions: false,
      isPulseContent: false,
      isPulsateIndividualQueries: false,
      isPulsatePresenterReplay: false,
      isConfirmbox: false,
      isWebinarActive: true,
      showChatPopup: false,
      selectedUserDetails: {},
      reply: "",
      selectedUserId: "",
      isFirstTimeLoading: true,
      showRatingsPopup: false,
      previousRouteName: "",
      interestedInRating: true,
      htmltoPrint: "",
      printObject: null,
      ratingQuestions: [],
      drawer: false,
      presentations: [],
      selectedPresentationId: "",
      slides: [
        {
          id: 0,
          name: "Slide 1",
        },
      ],
      isthumbnail: false,
      thumbnail: {},
      searchedPresentation: [],
      search: "",
    };
  },

  props: {
    parameter: {
      type: Object,
    },

    isPresenter: {
      type: Boolean,
    },

    documentId: {
      type: String,
      default: () => {
        return "";
      },
    },

    webinarId: {
      type: Number,
    },

    title: {
      type: String,
    },

    presenter: {
      type: String,
    },

    commence: {
      type: String,
    },

    isActive: {
      type: Boolean,
    },

    timeZone: {
      type: String,
    },
  },

  computed: {
    ...mapGetters(["getUserDetails", "getAccessToken"]),
  },

  async mounted() {
    this.isWebinarActive = this.isActive;
    this.uid = firebase.auth().currentUser.uid;
    if (this.documentId != undefined) {
      // await this.getRatingsQuestionnaire();
      await this.loadReportData();
    }

    this.$router.app.$on("openChatPopup", this.openChatPopup);

    // this.GetPresentations();
  },

  methods: {
    async loadReportData() {
      let context = this;
      ///Fetching the webinar report and common questions
      firestore
        .collection("WebinarReport")
        .doc(this.documentId)
        .onSnapshot(async function(doc) {
          if (context.documentId == doc.id && doc.exists == true) {
            context.webinarReport = doc.data().data;
          } else {
            var webinarReportSchema = ReportSchemaModel.WebinarReportSchma();
            webinarReportSchema.Presenter = context.presenter;
            webinarReportSchema.Title = context.title;
            context.webinarReport = await reportService.createorUpdateDocument(
              context.documentId,
              "WebinarReport",
              webinarReportSchema
            );
          }
        });

      firestore
        .doc(`WebinarReport/${this.documentId}/Users/${this.uid}`)
        .onSnapshot(async function(doc) {
          if (doc.exists && doc.data().Questiondetails != undefined) {
            context.userQuestionDetails = doc.data().Questiondetails;
            context.processRatings(doc.data().rating);
          } else {
            var individalQuestionSchema = {
              Questiondetails: ReportSchemaModel.WebinarUserQuestionsSchma(),
              rating: [],
            };
            await doc.ref.update(individalQuestionSchema);
          }
        });
    },

    async SaveReport() {
      this.$store.commit("toggleLoading", true);

      var addCommentSummerNote = document.getElementById(this.contentId);
      var addCommentSummerNoteContent = $(addCommentSummerNote).summernote(
        "code"
      );

      addCommentSummerNoteContent = await this.processSummerNoteContent(
        addCommentSummerNoteContent
      );
      if (addCommentSummerNoteContent.trim().length == 0) {
        this.$store.commit(
          "toaster",
          toasterModel("Comment is empty", toasterColor.info)
        );

        this.$store.commit("toggleLoading", false);
        return false;
      }

      this.webinarReport.Content =
        addCommentSummerNoteContent + " <br/> " + this.webinarReport.Content;

      this.reportStatus = await reportService.createorUpdateDocument(
        this.documentId,
        "WebinarReport",
        this.webinarReport
      );
      this.$store.commit("toaster", toasterModel("Comment added successfully"));
      this.clearSummerNote();
      this.$store.commit("toggleLoading", false);
    },

    clearSummerNote() {
      var addCommentSummerNote = document.getElementById(this.contentId);
      $(addCommentSummerNote).summernote("code", "");
    },

    async askQuestion() {
      if (this.question.trim() == "") {
        this.$store.commit(
          "toaster",
          toasterModel("Please enter a question", toasterColor.info)
        );
        this.question = "";
        return false;
      }

      var messageToAppend = utility.generateSummerNoteMessage(
        this.question,
        this.getUserDetails.userName
      );

      /* #region  Individal saving questions for user */

      this.userQuestionDetails.Questions =
        this.userQuestionDetails.Questions + "<br/>" + messageToAppend;

      let isQueried = {
        Questiondetails: {
          Questions: this.userQuestionDetails.Questions,
          LastQuestionAsked: firebase.firestore.FieldValue.serverTimestamp(),
          IsAnswered: false,
        },
      };

      const queryRef = firestore.doc(
        `WebinarReport/${this.documentId}/Users/${this.uid}`
      );
      await queryRef.update(isQueried);
      /* #endregion */

      /* #region  Question save in common area */

      this.webinarReport.Questions =
        '<div class="question" data-userId="' +
        this.uid +
        '" >' +
        messageToAppend +
        " </div> <br/>" +
        this.webinarReport.Questions;

      debugger;

      this.reportStatus = await reportService.createorUpdateDocument(
        this.documentId,
        "WebinarReport",
        this.webinarReport
      );
      /* #endregion */

      this.question = "";
    },

    // From html extract img tag and update it with new firebase url
    async processSummerNoteContent(summerNoteContent) {
      var html = $.parseHTML(summerNoteContent);

      var imageTags = $(html).find("img");
      let i = 0;
      for (i = 0; i < imageTags.length; i++) {
        var image = imageTags[i];
        let fetchBlobFromDataUrl = await fetch(image.src);

        if (fetchBlobFromDataUrl.ok) {
          var blob = await fetchBlobFromDataUrl.blob();

          var upload = await reportService.UploadImage(blob, Date.now());
          if (upload.state == "success") {
            var imageUrl = await upload.ref.getDownloadURL();
            image.src = imageUrl;
          }
        }
      }
      var div = $("<div</div>");
      div.append(html);

      return div[0].innerHTML;
    },

    async UpdateWebinarStatus() {
      this.isWebinarActive = !this.isWebinarActive;
      let webinar = {
        WebinarId: this.webinarId,
        IsActive: this.isWebinarActive,
      };

      let result = await townhallService.UpdateWebinarStatus(webinar);
      if (!result.error) {
        this.$router.app.$emit("initSummerNote");
        this.$store.commit(
          "toaster",
          toasterModel("Webinar close successfully", toasterColor.success)
        );
      } else {
        this.$store.commit(
          "toaster",
          toasterModel("Failed to close the Webinar", toasterColor.info)
        );
      }
      this.isConfirmbox = false;
    },

    openChatPopup(userId) {
      if (this.isPresenter) {
        this.selectedUserId = userId;
        this.showChatPopup = true;
        let context = this;
        var userStatusFirestoreRef = firebase
          .firestore()
          .doc("/WebinarReport/" + this.documentId + "/Users/" + userId);

        userStatusFirestoreRef.onSnapshot((user) => {
          context.selectedUserDetails = user.data();

          this.$nextTick(() => {
            if (context.isFirstTimeLoading) {
              context.scrollBottom();
              context.isFirstTimeLoading = false;
            }
          });
        });
      }
    },

    scrollBottom() {
      var parentDiv = $("#replySummerNote")[0].nextElementSibling;
      parentDiv.children[2].children[2].scrollTop =
        parentDiv.children[2].children[2].scrollHeight;
    },

    closeChatPopUp() {
      this.showChatPopup = false;
      this.selectedUserDetails = {};
      this.selectedUserId = "";
      this.isFirstTimeLoading = true;
    },

    async replyMessage() {
      if (this.reply.trim() == "") {
        this.$store.commit(
          "toaster",
          toasterModel("Please enter a reply", toasterColor.info)
        );
        this.reply = "";
        return false;
      }

      var messageToAppend = utility.generateSummerNoteMessage(
        this.reply,
        this.getUserDetails.userName
      );

      this.selectedUserDetails.Questiondetails.Questions =
        this.selectedUserDetails.Questiondetails.Questions +
        "<br/>" +
        messageToAppend;

      let isQueried = {
        Questiondetails: {
          Questions: this.selectedUserDetails.Questiondetails.Questions,
          IsAnswered: true,
          LastQuestionAsked: this.selectedUserDetails.Questiondetails
            .LastQuestionAsked,
        },
      };

      const queryRef = firestore.doc(
        `WebinarReport/${this.documentId}/Users/${this.selectedUserId}`
      );
      var result = await queryRef.update(isQueried);

      this.reply = "";
      this.showChatPopup = true;
    },

    async setRating() {
      debugger;
      let data = {
        rating: this.ratingQuestions,
      };
      const queryRef = firestore.doc(
        `WebinarReport/${this.documentId}/Users/${this.uid}`
      );
      await queryRef.update(data);
    },

    async rateNow(isRated = true) {
      let context = this;
      this.showRatingsPopup = false;
      if (isRated) {
        await this.setRating();
      } else {
        this.interestedInRating = false;
      }
      context.$router.push({ name: context.previousRouteName });
    },

    async printReports() {
      // let PrintedOn = new Date().toLocaleString();
      let context = this;
      let users = [];
      let userCollection = await firestore
        .collection("/WebinarReport/" + this.documentId + "/Users/")
        .get();
      userCollection.forEach((user) => {
        users.push(user.data());
      });

      context.printObject = {
        webinarDetails: context.webinarReport,
        users: users,
      };

      context.$nextTick(() => {
        debugger;
        var html = document.getElementById("webPrint").innerHTML;
        context.htmltoPrint = html;

        setTimeout(function() {
          context.$htmlToPaper("printReport");
        }, 3000);
      });
    },

    async getRatingsQuestionnaire() {
      let context = this;
      context.ratingQuestions = [];
      var result = await townhallService.GetRatingQuestionnaire();
      if (result.error == false) {
        result.data.forEach((x) => {
          context.ratingQuestions.push({
            question: x,
            rating: 0,
          });
        });
      }
    },

    // Set existing rating in the client
    processRatings(ratings) {
      let context = this;
      if (context.ratingQuestions.length > 0 && Array.isArray(ratings)) {
        ratings.forEach((x) => {
          var result = context.ratingQuestions.filter(
            (y) => y.question == x.question
          );
          if (result.length > 0) {
            result[0].rating = x.rating;
          }
        });
      }
    },

    openSlidesNavBar() {
      this.drawer = true;
      this.GetPresentations();
    },

    async GetPresentations() {
      let result = await townhallService.GetPresentations(this.getAccessToken);
      if (result.error) {
        return false;
      }

      //filtering the presentations from the files
      let presentationList = result.data.files
        .filter((x) => x.mimeType == "application/vnd.google-apps.presentation")
        .map((presentation) => {
          let item = {
            id: presentation.id,
            name: presentation.name,
          };
          return item;
        });

      this.presentations = presentationList;
      this.searchedPresentation = this.presentations;
    },

    SearchPresentation() {
      this.searchedPresentation = this.presentations.filter((x) => {
        var name = x.name.toLowerCase();

        if (name.includes(this.search.toLowerCase())) {
          return true;
        }
      });
    },

    async GetSlides(presentationId) {
      this.selectedPresentationId = presentationId;
      let result = await townhallService.GetSlides(
        this.getAccessToken,
        presentationId
      );

      if (result.error) {
        return false;
      }

      let slidesList = result.data.slides.map((slide, i) => {
        let item = {
          id: slide.objectId,
          name: "Slide " + (i + 1),
        };
        return item;
      });
      let promise = [];
      let thumbnailList = [];

      for (let i = 0; i < slidesList.length; i++) {
        promise.push(
          townhallService.GetThumbnail(
            this.getAccessToken,
            this.selectedPresentationId,
            slidesList[i].id
          )
        );
      }
      console.log(promise);

      thumbnailList = await Promise.all(promise);
      // for (let i = 0; i < slidesList.length; i++) {
      //   user_list[i]["result"] = result[i];
      // }
      console.log(thumbnailList);
      this.slides = slidesList;
    },

    async GetThumbnail(objectId) {
      let result = await townhallService.GetThumbnail(
        this.getAccessToken,
        this.selectedPresentationId,
        objectId
      );
      if (result.error) {
        return false;
      }
      this.thumbnail = result.data;
      this.isthumbnail = true;
    },
  },

  watch: {
    "webinarReport.Questions"(newValue, oldValue) {
      // Open chat Popup from webinar
      let context = this;
      context.$nextTick(() => {
        var elements = document.getElementsByClassName("question");
        Array.from(elements).forEach(function(element) {
          element.addEventListener("click", (event) => {
            var userId = event.target.getAttribute("data-userid");
            context.openChatPopup(userId);
          });
        });
      });

      if (oldValue != undefined) {
        this.ispulseQuestions = true;
        setTimeout(function() {
          context.ispulseQuestions = false;
        }, 7000);
      }
    },

    "webinarReport.Content"(newValue, oldValue) {
      if (oldValue != undefined) {
        let context = this;
        this.isPulseContent = true;
        setTimeout(function() {
          context.isPulseContent = false;
        }, 7000);
      }
    },

    "userQuestionDetails.Questions"(newValue, oldValue) {
      if (oldValue != undefined) {
        let context = this;
        this.isPulsatePresenterReplay = true;
        setTimeout(function() {
          context.isPulsatePresenterReplay = false;
        }, 7000);
      }
    },
    /* #region  Commented */

    // "selectedUserDetails.Questiondetails.Questions"(newValue, oldValue) {
    //   if (oldValue != undefined) {
    //     let context = this;
    //     this.isPulsateIndividualQueries = true;
    //     setTimeout(function () {
    //       context.isPulsateIndividualQueries = false;
    //     }, 7000);
    //   }
    // }
    /* #endregion */
  },

  beforeRouteLeave(to, from, next) {
    if (this.documentId) {
      if (
        !this.isPresenter &&
        this.ratingQuestions.length > 0 &&
        this.ratingQuestions.filter((x) => x.rating == 0).length > 0 &&
        this.interestedInRating
      ) {
        this.previousRouteName = to.name;
        this.showRatingsPopup = true;
        next(false);
      } else {
        var isOfflineForDatabase = {
          state: "offline",
          last_changed: firebase.database.ServerValue.TIMESTAMP,
          name: this.getUserDetails.userName,
          role: this.getUserDetails.role,
          area: this.getUserDetails.area,
          team: this.getUserDetails.team,
          office: this.getUserDetails.office,
          profileUrl: this.getUserDetails.profileUrl,
          isPresenter: this.isPresenter,
          webinarId: this.documentId,
        };
        var userStatusDatabaseRef = firebase
          .database()
          .ref("/status/" + this.uid);
        userStatusDatabaseRef.set(isOfflineForDatabase);
        next();
      }
    } else {
      next();
    }
  },

  beforeDestroy() {
    this.$router.app.$off("openChatPopup", this.openChatPopup);
  },
};
